// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.agm-modal-content {
  background: white;
  border-radius: 20px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: agm-slideIn 0.3s ease;
}

@keyframes agm-slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 20px 20px 0 0;
}

.agm-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
  margin: 0;
}

.agm-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.agm-modal-close:hover {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
}

.agm-modal-form {
  padding: 28px;
}

.agm-form-group {
  margin-bottom: 24px;
}

.agm-form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
  margin-bottom: 8px;
}

.agm-form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: white;
  color: #1f2937;
  box-sizing: border-box;
}

.agm-form-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.agm-form-input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
}

.agm-error-message {
  color: #dc2626;
  font-size: 14px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #fee2e2;
  border-radius: 6px;
  border: 1px solid #fecaca;
}

.agm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.agm-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 14px;
}

.agm-btn-primary {
  background: #002FA7;
  color: white;
}

.agm-btn-primary:hover:not(:disabled) {
  background: #1e40af;
  transform: translateY(-1px);
}

.agm-btn-secondary {
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
}

.agm-btn-secondary:hover:not(:disabled) {
  background: rgba(0, 47, 167, 0.05);
}

.agm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .agm-modal-content {
    margin: 10px;
  }

  .agm-modal-header {
    padding: 20px;
  }

  .agm-modal-title {
    font-size: 18px;
  }

  .agm-modal-form {
    padding: 20px;
  }

  .agm-modal-footer {
    flex-direction: column;
  }

  .agm-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/AddGroupModalStyle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".agm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.agm-modal-content {\n  background: white;\n  border-radius: 20px;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: agm-slideIn 0.3s ease;\n}\n\n@keyframes agm-slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agm-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 20px 20px 0 0;\n}\n\n.agm-modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0;\n}\n\n.agm-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #64748b;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.agm-modal-close:hover {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n}\n\n.agm-modal-form {\n  padding: 28px;\n}\n\n.agm-form-group {\n  margin-bottom: 24px;\n}\n\n.agm-form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n  margin-bottom: 8px;\n}\n\n.agm-form-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  background: white;\n  color: #1f2937;\n  box-sizing: border-box;\n}\n\n.agm-form-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.agm-form-input:disabled {\n  background: #f8fafc;\n  cursor: not-allowed;\n}\n\n.agm-error-message {\n  color: #dc2626;\n  font-size: 14px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #fee2e2;\n  border-radius: 6px;\n  border: 1px solid #fecaca;\n}\n\n.agm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.agm-btn {\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  font-size: 14px;\n}\n\n.agm-btn-primary {\n  background: #002FA7;\n  color: white;\n}\n\n.agm-btn-primary:hover:not(:disabled) {\n  background: #1e40af;\n  transform: translateY(-1px);\n}\n\n.agm-btn-secondary {\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n}\n\n.agm-btn-secondary:hover:not(:disabled) {\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.agm-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 640px) {\n  .agm-modal-content {\n    margin: 10px;\n  }\n\n  .agm-modal-header {\n    padding: 20px;\n  }\n\n  .agm-modal-title {\n    font-size: 18px;\n  }\n\n  .agm-modal-form {\n    padding: 20px;\n  }\n\n  .agm-modal-footer {\n    flex-direction: column;\n  }\n\n  .agm-btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
